export default __webpack_public_path__ + "static/media/1ab2cf65e2e4b258028730bba16917c7.svg";